import { createContext, MouseEventHandler, ReactNode, useContext } from 'react';
import { ModalSkin } from './BaseModalLayout.types';
import { TooltipProps } from '../Tooltip';
import { ButtonProps } from '../Button';

export type ModalLayoutContextProps = {
  illustrationClassName?: string;
  illustration?: ReactNode;
  /**
   * a global skin for the modal, will be applied as stylable state and will affect footer buttons skin.
   */
  skin?: ModalSkin;
  headerClassName?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  footnoteClassName?: string;
  footnote?: ReactNode;
  footerClassName?: string;
  actionsSize?: ButtonProps['size'];
  sideActions?: ReactNode;
  contentClassName?: string;
  content?: ReactNode;
  secondaryButtonText?: ReactNode;
  secondaryButtonOnClick?: MouseEventHandler;
  secondaryButtonProps?: Omit<ButtonProps, 'dataHook' | 'a'>;
  primaryButtonText?: ReactNode;
  primaryButtonOnClick?: MouseEventHandler;
  primaryButtonProps?: Omit<ButtonProps, 'dataHook'>;
  primaryButtonTooltipProps?: Omit<TooltipProps, 'children'>;
};

const BaseModalLayoutContext = createContext<ModalLayoutContextProps>({});

function useBaseModalLayoutContext() {
  return useContext(BaseModalLayoutContext) || {};
}

export { BaseModalLayoutContext, useBaseModalLayoutContext };
